import React from 'react'
import RequestBudget from 'src/app/RequestBudget/RequestBudget'
import { SidenavContentType } from 'src/navigation/appLocations'
import { AppRoute } from 'src/navigation/appRoutes'
import { requestBudgetRouteProps } from 'src/navigation/routeProps'

import { AppLocation } from '../appLocations'

const RequestBudgetAppRoute: AppRoute = {
  id: AppLocation.RequestBudget,
  routeProps: requestBudgetRouteProps,
  component: <RequestBudget />,
  subRoutes: [],
  meta: { contentType: SidenavContentType.Main },
}

export default RequestBudgetAppRoute
